export default "__VITE_ASSET__inFvRNmr__"